import * as d3 from "d3";
import * as points from "./models/points.js";
import * as lattice from "./views/lattice.js";
import * as focus from "./views/focus.js";


export function launchContext(config, userInput){
    d3.select(`#${config.rootId} svg`).remove();

    if (userInput.scatter == false){
        let baseUrl = config.baseUrl;
        let dependencyHeatmapUrl = `${baseUrl}dependency_heatmap?c=${userInput.c}&l=${userInput.l}`;
        let densityHistogramUrl = `${baseUrl}density_histogram?c=${userInput.c}&l=${userInput.l}`;
    
        Promise.all([    
            $.getJSON(dependencyHeatmapUrl, result=> result),
            $.getJSON(densityHistogramUrl, result=> result)
        ])
        .then((result) => {
            result[0].sort(function(a,b){ return d3.ascending(a.cl, b.cl)})
            result[1].sort(function(a,b){ return d3.ascending(a.cl, b.cl)})
            let heatmapData = points.createHeatmapData(result[0])
            let histogramData = points.createHistogramData(result[1])
            let lineplotData = points.createLineplotData(histogramData, userInput)
            let columnplotData = points.createColumnplotData(histogramData)
            lattice.render(heatmapData.concat(histogramData).concat(lineplotData).concat(columnplotData), config, userInput);
        })
    }
}

export function launchFocus(config, userInput){

    d3.select(`#${config.rootId}`).select("svg").remove();
    d3.select(`#${config.rootId}`).select("canvas").remove();

    $('#table').DataTable().clear().rows.add([]).draw();

    // d3.selectAll(".ljs--lattice-plot").classed("active", false)

    let baseUrl = config.baseUrl;
    let createUrl = ()=>{
        let url;
        if (userInput.scatter){
            url = `${baseUrl}dependency?cl=${userInput.cl},${userInput.cl2}&c=${userInput.c},${userInput.c2}&l=${userInput.l},${userInput.l}&scatter=True`;
        } else {
            url = `${baseUrl}dependency?cl=${userInput.cl}&c=${userInput.c}&l=${userInput.l}&scatter=false`;
        }

        return url;
    }

    Promise.all([    
        $.getJSON(createUrl(), result=> result)
    ])
    .then((result)=>{


        let data;
        if (userInput.scatter){
            data = points.createScatterPoints(result[0])
        } else {
            data = points.createVolcanoPoints(result[0])
        }

        focus.render(data, config, userInput)  

    })
}
